import { TicketSelectionApplicationData } from "@/domain/ticket-selection";

export class SeatmapPriceCategoryAvailabilityProvider {

    /**
     * whatItDoes
     * provides available price level ids for seatmap selection
     */
    public static setPriceCategoryAvailabilityForApplication(data: TicketSelectionApplicationData): TicketSelectionApplicationData {
        if (!data.priceList) {
            return data;
        }

        if (!data.priceList.priceLevels) {
            return data;
        }

        if (!data.seatmapConfig) {
            return data;
        }

        data.seatmapConfig.filteredPriceCategories = data.priceList.priceLevels.map(item => item.priceLevelId);

        return data;
    }

}
